import { isAfter, subDays } from 'date-fns'
import { BOX_OFFICE_TRACKER_SLUG, PRESALE_TRACKER_SLUG } from '@/constants/goalTrackers'

const BOX_OFFICE_TRACKER_RELEASE_OFFSET_DAYS = 1

export interface GoalTrackerTitleContent {
  key: 'totalBoxOffice' | 'totalPreSales'
  defaultValue: 'Total Box Office' | 'Total Pre Sales'
}

export function isBoxOfficeTrackerReleased(releaseDate: string | null | undefined, currentDate = new Date()): boolean {
  return releaseDate
    ? isAfter(currentDate, subDays(new Date(releaseDate), BOX_OFFICE_TRACKER_RELEASE_OFFSET_DAYS))
    : false
}

export function getGoalTrackerSlug(releaseDate: string | null | undefined, currentDate = new Date()): string {
  return isBoxOfficeTrackerReleased(releaseDate, currentDate) ? BOX_OFFICE_TRACKER_SLUG : PRESALE_TRACKER_SLUG
}

export function getGoalTrackerTitleContent(
  releaseDate: string | null | undefined,
  currentDate = new Date(),
): GoalTrackerTitleContent {
  return isBoxOfficeTrackerReleased(releaseDate, currentDate)
    ? { key: 'totalBoxOffice', defaultValue: 'Total Box Office' }
    : { key: 'totalPreSales', defaultValue: 'Total Pre Sales' }
}
